import isIn from 'validator/es/lib/isIn';
import { TradeDirections } from 'src/util/constants';

/**
 * Validates the provided trade direction against the list of valid trade directions.
 * @param {string} direction - The trade direction to validate.
 * @returns {boolean} - True if the provided direction is part of the provided trade directions,
 * false otherwise.
 */
const isValid = (direction) => isIn(direction, TradeDirections);

export default isValid;
